// extracted by mini-css-extract-plugin
var _1 = "ControlBarPopOver-module__animatedBackground--FXDY6";
var _2 = "ControlBarPopOver-module__arrowBg--D0C8y";
var _3 = "ControlBarPopOver-module__arrowStroke--Pxlxl";
var _4 = "ControlBarPopOver-module__floatingContainer--kO0Rp";
var _5 = "ControlBarPopOver-module__inner--_xjHy";
export { _1 as "animatedBackground", _2 as "arrowBg", _3 as "arrowStroke", _4 as "floatingContainer", _5 as "inner" }
